import React from 'react';

// Section 1 — Deals & Strategy hero.
export const DealsHero = () => (
  <section id="top" className="pt-20 pb-20 sm:pt-28 sm:pb-28 px-6 sm:px-10 lg:px-16 border-b border-stone-200/80 bg-[#FBFBFB]">
    <div className="w-full max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
      <div className="hidden lg:block lg:col-span-4" />
      <div className="lg:col-span-8 max-w-3xl">
        <div className="text-xs uppercase tracking-wider mb-6 flex items-center gap-2 font-sans font-medium text-stone-500">
          <span className="font-bold text-stone-950 tracking-[0.16em]">DEALS & STRATEGY</span>
          <span className="text-stone-300">·</span>
          <span className="text-stone-600 font-semibold tracking-wider text-[11px] sm:text-xs">FULL-LIFECYCLE COVERAGE ACROSS EVERY MANDATE</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] xl:text-[3.5rem] font-bold tracking-tight text-stone-950 leading-[1.1] mb-8">
          Across every stage. Every mandate.
        </h1>

        <div className="space-y-5 text-base sm:text-lg text-stone-700 leading-relaxed font-sans font-normal">
          <p className="text-lg sm:text-xl text-stone-900 font-medium leading-snug">
            Frontier Deal OS™ deploys across the entire deal lifecycle — from sourcing to exit — and adapts to the exact underwriting stakes of every fund, practice, and mandate.
          </p>
          <p>
            Compress multi-week diligence into days, stress-test more hypotheses with deep sector context, and underwrite with absolute conviction — whether you're a venture fund, a buyout sponsor, a corporate acquirer, a strategy practice, or an investment bank.
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-2.5">
          {['Sourcing', 'Diligence', 'Value Creation', 'Strategic Exit'].map((s) => (
            <span key={s} className="text-[11px] font-mono font-semibold text-stone-700 bg-stone-100 border border-stone-200 px-3 py-1.5 rounded-full">{s}</span>
          ))}
        </div>
      </div>
    </div>
  </section>
);
